import { useNavigate, useLocation } from "react-router-dom";
import {
  Database,
  Settings,
  Home,
  Bell,
  Store,
  LineChart,
} from "lucide-react";

export const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const navItems = [
    { path: '/dashboard', icon: Home, label: 'Home' },
    { path: '/vault', icon: Database, label: 'Vault' },
    { path: '/market', icon: Store, label: 'Market' },
    { path: '/analytics', icon: LineChart, label: 'Analytics' },
    { path: '/settings', icon: Settings, label: 'Settings' },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-slate-900/95 backdrop-blur-lg border-t border-purple-500/20 z-40 lg:hidden">
      <div className="flex justify-around items-center py-2">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`flex flex-col items-center py-2 px-3 rounded-xl transition ${
                isActive 
                  ? 'text-cyan-400' 
                  : 'text-gray-500 hover:text-gray-300'
              }`}
            >
              <item.icon className={`w-5 h-5 ${isActive ? 'text-cyan-400' : ''}`} />
              <span className="text-xs mt-1">{item.label}</span>
            </button>
          );
        })}      </div>
    </nav>
  );
};

// Notification Bell Component
